import React from "react";

import { getRoleModuleTitles } from "~/components/layout/utils/menuItems";
import { Badge } from "~/components/ui/badge";
import { UserRole } from "~/types/user";

interface RoleModulesPreviewProps {
  role: UserRole;
}

/**
 * Shows which sidebar modules/tabs the selected role will unlock, so admins
 * can confirm access before creating or editing a user.
 */
export const RoleModulesPreview: React.FC<RoleModulesPreviewProps> = ({
  role,
}) => {
  const modules = getRoleModuleTitles(role);

  return (
    <div className="rounded-lg border bg-muted/40 p-3">
      <p className="mb-2 text-xs font-medium text-muted-foreground">
        Módulos visibles para este rol
      </p>
      {modules.length > 0 ? (
        <div className="flex flex-wrap gap-1.5">
          {modules.map((moduleTitle) => (
            <Badge key={moduleTitle} variant="secondary" className="font-normal">
              {moduleTitle}
            </Badge>
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">
          Este rol no tiene módulos en el menú.
        </p>
      )}
    </div>
  );
};
